export default "__VITE_ASSET__B6Te8$Ze__"